

























































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Helper } from '@/helpers/Helper'
import PageHead from '@/components/PageHead.vue'
import TinyMCE from '@/components/TinyMCE.vue'
import { Notify } from '@/helpers/Notify'
import { Api } from '@/fetch/Api'
import type { Page } from '@/interfaces'
import store from '@/store'

@Component({
  components: {
    TinyMCE,
    PageHead,
  },
})
export default class PageEdit extends Vue {
  pageTitle = 'Edit Web Page'
  testPageInfo = 'Please click the \'enter\' (return) key on your keyboard to create a new paragraph. For a simple line break (starting a new sentence on the next line, without creating a new paragraph), click \'shift\' and \'enter\' at the same time.'
  callInProgress = false
  page: Page = null
  domainImages = null
  urlScheme = window.location.protocol
  heroImagesSelection = []

  created() {
    this.fetchDomainPage()
  }

  @Watch('$route.params.id')
  onVariable() {
    this.fetchDomainPage()
  }

  public updateContent(content) {
    this.page.content = content
  }

  public async fetchDomainPage() {
    this.callInProgress = true
    try {
      this.page = await Api.getDomainPage(parseInt(this.$route.params.id))
      const domainImagesResponse = await Api.getDomainImages()
      this.heroImagesSelection = this.page.heroImages
      this.domainImages = domainImagesResponse.domainImages
      this.callInProgress = false
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }

  public async saveChanges() {
    this.callInProgress = true
    try {
      this.page.heroImages = this.heroImagesSelection
      await Api.updateDomainPage(this.page)
      this.callInProgress = false
      store.commit('toggleFlag', 'reloadNav')
      Notify.create({
        type: 'success',
        title: 'Saved!',
        text: 'Web Page Content Saved.',
      })
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }

  public changePreviewSrc(event, heroImageId) {
    this.heroImagesSelection[heroImageId] = event.target.value
  }

  public getHeroImageSrc(heroImageFileName) {
    return this.urlScheme + '//' + Helper.getCurrentDomain() + '/images/' + heroImageFileName
  }
}
